import { BrowserRouter as Router } from 'react-router-dom';

import RutasAplicacion from 'app/router/RutasAplicacion';

const App = () => (
  <Router>
    <div className="App">
      <RutasAplicacion />
    </div>
  </Router>
);

export default App;
